export default __webpack_public_path__ + "static/header-bg-pattern-51467dd055e8cab556afa79d99d13c01.png";